import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Form, Button, Input, Row, Col, message } from 'antd';
import TextArea from 'antd/es/input/TextArea'
import { InfoCircleOutlined, SyncOutlined } from '@ant-design/icons';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import apiClient from 'services/apiClient';
import { useMyContext } from 'Context/MyContextProvider';
import { useMobileHeader } from 'layouts/inner-app-layout';
import ConditionalRender from 'views/app-views/whatsapp/Utils/ConditionalRender';

const CardHeader = () => {
    const { isMobile } = useMyContext();

    return (
        <div className="d-flex align-items-center" style={{ width: '100%' }}>
            <div
                className="d-flex align-items-center justify-content-center mr-3"
                style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '8px',
                    backgroundColor: '#eef2fe',
                    flexShrink: 0
                }}
            >
                <svg
                    aria-label="Meta symbol"
                    height="32"
                    role="img"
                    viewBox="0 0 150 100"
                    width="48"
                >
                    <defs>
                        <linearGradient
                            gradientUnits="userSpaceOnUse"
                            id="_r_0_"
                            x1="124.599"
                            x2="159.703"
                            y1="96.689"
                            y2="57.25"
                        >
                            <stop offset="0.21" stopColor="#0278F1" />
                            <stop offset="0.533" stopColor="#0180FA" />
                        </linearGradient>
                        <linearGradient
                            gradientUnits="userSpaceOnUse"
                            id="_r_1_"
                            x1="43.859"
                            x2="0"
                            y1="4.984"
                            y2="63.795"
                        >
                            <stop offset="0.427" stopColor="#0165E0" />
                            <stop offset="0.917" stopColor="#0180FA" />
                        </linearGradient>
                        <linearGradient
                            gradientUnits="userSpaceOnUse"
                            id="_r_2_"
                            x1="28.409"
                            x2="134.567"
                            y1="28.907"
                            y2="71.769"
                        >
                            <stop stopColor="#0064E0" />
                            <stop offset="0.656" stopColor="#0066E2" />
                            <stop offset="1" stopColor="#0278F1" />
                        </linearGradient>
                    </defs>
                    <path
                        d="M107.654 0c-12.3 0-21.915 9.264-30.618 21.032C65.076 5.802 55.073 0 43.103 0 18.698 0 0 31.76 0 65.376 0 86.41 10.177 99.679 27.223 99.679c12.268 0 21.092-5.784 36.778-33.203 0 0 6.539-11.547 11.037-19.501a514.1 514.1 0 0 1 4.98 8.227l7.356 12.374c14.329 23.977 22.312 32.103 36.778 32.103C140.758 99.68 150 86.23 150 64.757 150 29.56 130.88 0 107.654 0ZM52.039 59.051C39.322 78.987 34.922 83.455 27.841 83.455c-7.287 0-11.617-6.397-11.617-17.804 0-24.404 12.167-49.359 26.672-49.359 7.855 0 14.42 4.537 24.474 18.93-9.547 14.645-15.33 23.83-15.33 23.83Zm47.999-2.51-8.795-14.667c-2.38-3.87-4.66-7.428-6.862-10.689 7.927-12.234 14.465-18.33 22.241-18.33 16.155 0 29.079 23.786 29.079 53.002 0 11.137-3.647 17.599-11.205 17.599-7.244 0-10.704-4.785-24.458-26.914Z"
                        fill="#0180FA"
                    />
                    <path
                        d="M145.119 34.888h-14.878c3.44 8.718 5.46 19.42 5.46 30.969 0 11.137-3.647 17.599-11.205 17.599-1.403 0-2.663-.18-3.884-.63V99.5a33.48 33.48 0 0 0 3.54.18C140.758 99.68 150 86.23 150 64.756c0-10.702-1.768-20.882-4.881-29.87Z"
                        fill="url(#_r_0_)"
                    />
                    <path
                        d="M43.103 0c.253 0 .505.003.756.008v16.308c-.319-.016-.64-.024-.962-.024-14.138 0-26.055 23.706-26.65 47.503H.014C.588 30.77 19.08 0 43.103 0Z"
                        fill="url(#_r_1_)"
                    />
                    <path
                        d="M43.103 0c11.115 0 20.534 5.004 31.4 17.913 3.055 3.817 6.74 8.777 10.682 14.511l.017.025.024-.003c1.939 2.912 3.94 6.05 6.017 9.428l8.795 14.668c13.754 22.13 17.214 26.913 24.458 26.913h.103v16.22c-.148.003-.297.004-.447.004-14.466 0-22.449-8.126-36.778-32.103l-7.356-12.374a587.065 587.065 0 0 0-2.287-3.822l.019-.045c-5.483-8.971-8.971-14.454-11.962-18.44l-.05.037c-9.15-12.59-15.42-16.64-22.842-16.64h-.034V.001l.24-.001Z"
                        fill="url(#_r_2_)"
                    />
                </svg>
            </div>
            <div style={{ flex: 1 }}>
                <ConditionalRender condition={!isMobile}>
                    <h3 className="mb-0 font-weight-semibold" style={{ fontSize: '15px', color: '#1a1a1a', lineHeight: '1.2' }}>
                        Meta Credential
                    </h3>
                </ConditionalRender>
                <div className="text-muted" style={{ fontSize: '11px', marginTop: '2px', whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '1.3' }}>
                    Enter your Meta API credentials to connect your WhatsApp Business Account.
                </div>
            </div>
        </div>
    );
};

const MetaCredential = ({ api, authToken, navigate, id }) => {
    const { Permisson, userRole, encryptData, isMobile } = useMyContext()

    useMobileHeader(
        <CardHeader />
    );

    const [isUserVerified, setIsUserVerified] = useState(false)

    const [app_id, setApp_id] = useState('');
    const [password, setPassword] = useState('');
    const [disable, setDisable] = useState(true)
    const [isAdmin, setIsAdmin] = useState(false)
    const [whatsapp_business_account_id, setWhatsapp_bussiness_account_id] = useState('');
    const [business_account_id, setBussiness_account_ID] = useState('');
    const [meta_access_token, setMeta_access_token] = useState('');
    const [whatsapp_phone_id, setWhatsapp_phone_id] = useState('');
    const [whatsapp_phone_number, setWhatsapp_phone_number] = useState('');
    const [loading, setLoading] = useState(false);
    const [secondsRemaining, setSecondsRemaining] = useState(0);
    const expiryTimerRef = useRef(null);
    const [isHovered, setIsHovered] = useState(false);

    const clearCredentialFields = useCallback(() => {
        setApp_id('');
        setWhatsapp_bussiness_account_id('');
        setBussiness_account_ID('');
        setMeta_access_token('');
        setWhatsapp_phone_id('');
        setWhatsapp_phone_number('');
    }, []);

    const lockCredentials = useCallback((notify = true) => {
        if (expiryTimerRef.current) {
            clearInterval(expiryTimerRef.current);
            expiryTimerRef.current = null;
        }
        setIsUserVerified(false);
        setSecondsRemaining(0);
        setPassword('');
        clearCredentialFields();
        if (notify) {
            message.warning('Credential access expired. Please verify your password again.');
        }
    }, [clearCredentialFields]);

    const handleExtendTime = useCallback(() => {
        if (expiryTimerRef.current) {
            clearInterval(expiryTimerRef.current);
            expiryTimerRef.current = null;
        }
        setIsUserVerified(false);
        setSecondsRemaining(0);
        setPassword('');
    }, []);

    const startCredentialTimer = useCallback((expiresIn) => {
        const ttl = Number(expiresIn) > 0 ? Number(expiresIn) : 300;
        const expiresAt = Date.now() + ttl * 1000;

        if (expiryTimerRef.current) {
            clearInterval(expiryTimerRef.current);
        }

        const tick = () => {
            const remaining = Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
            setSecondsRemaining(remaining);

            if (remaining <= 0) {
                clearInterval(expiryTimerRef.current);
                expiryTimerRef.current = null;
                lockCredentials();
            }
        };

        tick();
        expiryTimerRef.current = setInterval(tick, 1000);
    }, [lockCredentials]);

    useEffect(() => {
        return () => {
            if (expiryTimerRef.current) {
                clearInterval(expiryTimerRef.current);
            }
        };
    }, []);

    const formatCountdown = (totalSeconds) => {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

    const GetData = useCallback(async (credentialToken) => {
        setLoading(true);
        await apiClient.get(`${api}get-credential/${id}`, {
            headers: {
                'Authorization': 'Bearer ' + authToken,
                ...(credentialToken ? { 'X-Credential-Token': credentialToken } : {}),
            }
        })
            .then(response => {
                const data = response.data?.history[0];
                setApp_id(data?.app_id);
                setWhatsapp_bussiness_account_id(data?.whatsapp_business_account_id);
                setBussiness_account_ID(data?.business_account_id);
                setMeta_access_token(data?.meta_access_token);
                setWhatsapp_phone_id(data?.whatsapp_phone_id);
                setWhatsapp_phone_number(data?.user?.whatsapp_number);
                setLoading(false);

            })
            .catch(error => {
                setLoading(false);
                if (error.response?.status === 403) {
                    lockCredentials(false);
                    message.error('Credential access not verified. Please verify your password again.');
                } else {
                    console.log(error);
                }
            });
    }, [api, id, authToken, lockCredentials]);

    useEffect(() => {

        if (Permisson?.includes('Update Meta Credential')) {
            setDisable(false)
        }
        // Admins can view credentials directly; non-admins must verify their
        // password first, so we defer the fetch until HandleVerify succeeds.
        if (userRole === 'Admin') {
            setIsAdmin(true)
            GetData()
        }
    }, [Permisson, userRole, GetData])

    const UpdateUser = async (e) => {
        e.preventDefault();
        // console.log(business_account_id)
        await apiClient.post(`${api}update-credential`, {
            user_id: id,
            app_id,
            whatsapp_business_account_id,
            business_account_id,
            meta_access_token,
            whatsapp_phone_id,
            whatsapp_number: whatsapp_phone_number
        }, {
            headers: {
                'Authorization': 'Bearer ' + authToken,
            }
        }).then((response) => {
            message.success(response.data.message)
        }).catch((error) => {
            console.log(error);
        });

    }


    const HandleVerify = async () => {
        if (password) {
            await apiClient.post(`${api}chek-password`, {
                id: id,
                password
            }, {
                headers: {
                    'Authorization': 'Bearer ' + authToken,
                }
            })
                .then((response) => {
                    setIsUserVerified(true)
                    startCredentialTimer(response.data?.expires_in)
                    GetData(response.data?.hash)
                    message.success(response.data.message)
                    setLoading(false)
                    setPassword('')
                })
                .catch((error) => {
                    // console.log(error.response)
                    message.error(error.response?.data?.error || 'Verification failed');
                });
        }
    }





    return (
        <>
            <div className="mt-4">
                <ConditionalRender condition={!isMobile}>
                    <div className="mb-3">
                        <CardHeader />
                    </div>
                </ConditionalRender>

                <ConditionalRender condition={!loading && isAdmin}>
                    <Form
                        name="basicInformation"
                        layout="vertical"
                        disabled={disable}
                    >
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={16}>
                                <Row gutter={ROW_GUTTER}>
                                    <Col xs={24} sm={24} md={12}>
                                        <Form.Item
                                            label="App ID"
                                            name="app_id"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input your App ID!',
                                                },
                                            ]}
                                            initialValue={encryptData(app_id)}
                                        >
                                            <Input onChange={(e) => setApp_id(e.target.value)} />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} sm={24} md={12}>
                                        <Form.Item
                                            label="Whatsapp Business Account ID"
                                            name="whatsapp_business_account_id"
                                            rules={[{
                                                required: true,
                                                type: 'text',
                                                message: 'Please enter a valid Whatsapp Business Account ID!'
                                            }]}
                                            initialValue={encryptData(whatsapp_business_account_id)}
                                        >
                                            <Input onChange={(e) => setWhatsapp_bussiness_account_id(e.target.value)} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12}>
                                        <Form.Item
                                            label="Bussiness ID"
                                            name="bussiness_account_ID"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input your Bussiness account ID!',
                                                },
                                            ]}
                                            initialValue={encryptData(business_account_id)}
                                        >
                                            <Input onChange={(e) => setBussiness_account_ID(e.target.value)} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12}>
                                        <Form.Item
                                            label="Meta Access Token"
                                            name="meta_access_token"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input your Meta Access Token!',
                                                },
                                            ]}
                                            initialValue={encryptData(meta_access_token)}
                                        >
                                            <TextArea rows={5} onChange={(e) => setMeta_access_token(e.target.value)} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12}>
                                        <Form.Item
                                            label="Whatsapp Phone ID"
                                            name="whatsapp_phone_id"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input your Whatsapp Phone ID!',
                                                },
                                            ]}
                                            initialValue={encryptData(whatsapp_phone_id)}
                                        >
                                            <Input onChange={(e) => setWhatsapp_phone_id(e.target.value)} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12}>
                                        <Form.Item
                                            label="Whatsapp Phone Number"
                                            name="whatsapp_phone_number"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input your Whatsapp Phone Number!',
                                                },
                                            ]}
                                            initialValue={encryptData(whatsapp_phone_number)}
                                        >
                                            <Input onChange={(e) => setWhatsapp_phone_number(e.target.value)} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <div className='d-flex justify-content-between'>
                                    <div className='action btn'>
                                        <Button type="primary" className='mr-2' danger onClick={(e) => navigate('/users')}>
                                            Cancel
                                        </Button>
                                        <ConditionalRender condition={Permisson?.includes('Update Meta Credential')}>
                                            <Button type="primary" htmlType="submit" onClick={(e) => UpdateUser(e)}>
                                                Save Change
                                            </Button>
                                        </ConditionalRender>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                    </Form>
                </ConditionalRender>

                <ConditionalRender condition={!loading && !isAdmin && isUserVerified}>
                    <Form
                        name="basicInformation"
                        layout="vertical"
                        disabled={disable}
                    >
                        <div
                            className="mb-4"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '12px 20px',
                                backgroundColor: '#f4faf6',
                                border: '1px solid #e1f5e8',
                                borderRadius: '8px',
                                width: '100%',
                                gap: '12px',
                                flexWrap: 'wrap'
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <InfoCircleOutlined style={{ fontSize: '16px', color: '#28a745' }} />
                                <span style={{ color: '#5f6368', fontSize: '13px' }}>
                                    Credential access expires in{' '}
                                    <span style={{ color: '#28a745', fontWeight: '600' }}>
                                        {formatCountdown(secondsRemaining)}
                                    </span>
                                </span>
                            </div>
                            <div
                                style={{
                                    color: '#5f6368',
                                    fontSize: '13px',
                                    flex: '1 1 auto',
                                    textAlign: 'center',
                                    minWidth: '200px'
                                }}
                            >
                                For security, you will need to verify your password again when the timer ends.
                            </div>
                            <div
                                onClick={handleExtendTime}
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    color: '#28a745',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    fontSize: '13px',
                                    userSelect: 'none',
                                    opacity: isHovered ? 0.8 : 1,
                                    transition: 'opacity 0.15s ease'
                                }}
                            >
                                <SyncOutlined style={{ fontSize: '14px' }} />
                                <span>Extend Time</span>
                            </div>
                        </div>
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={16}>
                                <Row gutter={ROW_GUTTER}>
                                    <Col xs={24} sm={24} md={12}>
                                        <Form.Item
                                            label="App ID"
                                            name="app_id"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input your App ID!',
                                                },
                                            ]}
                                            initialValue={encryptData(app_id)}
                                        >
                                            <Input onChange={(e) => setApp_id(e.target.value)} />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} sm={24} md={12}>
                                        <Form.Item
                                            label="Whatsapp Business Account ID"
                                            name="whatsapp_business_account_id"
                                            rules={[{
                                                required: true,
                                                type: 'text',
                                                message: 'Please enter a valid Whatsapp Business Account ID!'
                                            }]}
                                            initialValue={encryptData(whatsapp_business_account_id)}
                                        >
                                            <Input onChange={(e) => setWhatsapp_bussiness_account_id(e.target.value)} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12}>
                                        <Form.Item
                                            label="Bussiness ID"
                                            name="bussiness_account_ID"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input your Bussiness account ID!',
                                                },
                                            ]}
                                            initialValue={encryptData(business_account_id)}
                                        >
                                            <Input onChange={(e) => setBussiness_account_ID(e.target.value)} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12}>
                                        <Form.Item
                                            label="Meta Access Token"
                                            name="meta_access_token"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input your Meta Access Token!',
                                                },
                                            ]}
                                            initialValue={encryptData(meta_access_token)}
                                        >
                                            <TextArea rows={5} onChange={(e) => setMeta_access_token(e.target.value)} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12}>
                                        <Form.Item
                                            label="Whatsapp Phone ID"
                                            name="whatsapp_phone_id"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input your Whatsapp Phone ID!',
                                                },
                                            ]}
                                            initialValue={encryptData(whatsapp_phone_id)}
                                        >
                                            <Input onChange={(e) => setWhatsapp_phone_id(e.target.value)} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <div className='d-flex justify-content-end'>
                                    <Button type="primary" className='mr-2' danger onClick={(e) => navigate('/users')}>
                                        Cancel
                                    </Button>
                                    <ConditionalRender condition={Permisson?.includes('Update Meta Credential')}>
                                        <Button type="primary" htmlType="submit" onClick={(e) => UpdateUser(e)}>
                                            Save Change
                                        </Button>
                                    </ConditionalRender>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </ConditionalRender>

                <ConditionalRender condition={!loading && !isAdmin && !isUserVerified}>
                    <Form
                        name="basicInformation"
                        layout="vertical"
                    >
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={12}>
                                <div className='border-0 rounded p-3'
                                    style={{
                                        background: '#fafafb',
                                        boxShadow: 'rgba(27, 37, 49, 0.1) 0px 2px 10px' // Note: Corrected alpha value
                                    }}
                                >
                                    <Row gutter={ROW_GUTTER}>
                                        <Col xs={24} sm={24} md={16}>
                                            <Form.Item
                                                label="Enter Your Password"
                                                name="password"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please enter your password!'
                                                    }
                                                ]}
                                            >
                                                <Input.Password
                                                    size="middle"
                                                    name="password"
                                                    value={password}
                                                    autoComplete="new-password"
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={24} md={24}>
                                            <span style={{ fontSize: '12px' }}>Kindly verify yourself using your login password for better, smooth & protected experience</span>
                                        </Col>
                                        <Col xs={24} sm={24} md={24} className='mt-4'>
                                            <Button type="primary" className='' htmlType="submit" onClick={(e) => HandleVerify(e)}>
                                                Verify
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>


                    </Form>
                </ConditionalRender>
            </div>
        </>
    )
}

export default MetaCredential